import { YodleeLinkResponse } from "./../api/YodleeService";
import { parse } from "qs";

// example payload
// "bankName": "DagBank",
// "code": 0,
// "intermediateFlowTransition": 0,
// "isCBLFlow": 1,
// "itemAccountId": 57579020,
// "itemId": 40776572,
// "providerAccountId": 23734900,
// "reason": "REFRESH_COMPLETED",
// "status": "VERIFICATION_SUCCESS",
interface ParsedStatus {
  bankName: string;
  code: number;
  intermediateFlowTransition: number;
  isCBLFlow: number;
  itemAccountId: number;
  itemId: number;
  providerAccountId: number;
  reason: string;
  status: string;
}

export const parseAccountDataFromYodleeCallbackUrl = (url: string) => {
  const { JSONcallBackStatus }: Record<string, any> = parse(url) || {};
  // console.log({ JSONcallBackStatus });
  const parsedStatus: ParsedStatus = JSON.parse(JSONcallBackStatus || "{}");
  // console.log({ parsedStatus });
  return parsedStatus;
};

interface IParams {
  accountDataFromAPI: YodleeLinkResponse;
  userName: string;
  reservationId: string;
  allowCof: boolean;
}

export const turnFullAccountDataIntoCreatablePaymentSource = ({
  accountDataFromAPI,
  userName,
  reservationId,
  allowCof = false,
}: IParams) => {
  const { account_number, routing_number, bank_account_type, yodlee_account_id } =
    accountDataFromAPI;
  return {
    accountHolder: userName,
    cardholder: userName,
    accountType: bank_account_type,
    routingNumber: routing_number,
    accountNumber: account_number,
    bankAccountNumber: account_number,
    paymentRoutingNumber: routing_number,
    confirmAccountNumber: account_number,
    bankAccountType: bank_account_type,
    allowCof,
    paymentType: "DOMUSO_CASH",
    reservationId,
    paymentSourceType: "BANK_ACCOUNT",
    yodleeAccountId: yodlee_account_id,
  };
};
